import { Platform, StyleSheet } from "react-native";
import { useColorScheme } from "../design-system/colorScheme";
import { type Theme, createTheme, lightTheme } from "../design-system/theme";

export function useComposeChatStyles() {
	const scheme = useColorScheme();
	return composeChatStylesFor(createTheme(scheme));
}

export function composeChatStylesFor(theme: Theme) {
	return StyleSheet.create({
		container: {
			flex: 1,
			backgroundColor: theme.colors.surface.primary,
		},
		header: {
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between",
			paddingHorizontal: theme.spacing.lg,
			paddingVertical: theme.spacing.md,
			borderBottomWidth: StyleSheet.hairlineWidth,
			borderBottomColor: theme.colors.border.secondary,
		},
		cancelButton: {
			fontSize: theme.typography.fontSize.body,
			color: theme.colors.accent.indigo,
			width: 64,
			cursor: Platform.select({ web: "pointer", default: "auto" }) as any,
		},
		title: {
			fontSize: theme.typography.fontSize.headline,
			fontWeight: "600",
			color: theme.colors.text.primary,
		},
		headerSpacer: {
			width: 64,
		},
		content: {
			flex: 1,
			paddingHorizontal: theme.spacing.lg,
			paddingTop: theme.spacing.xl,
		},
		inputContainer: {
			marginBottom: theme.spacing.lg,
		},
		label: {
			fontSize: theme.typography.fontSize.footnote,
			fontWeight: "600",
			color: theme.colors.text.secondary,
			marginBottom: theme.spacing.xs,
		},
		input: {
			backgroundColor: theme.colors.surface.secondary,
			borderRadius: theme.radii.md,
			paddingHorizontal: theme.spacing.md,
			paddingVertical: theme.spacing.md,
			fontSize: theme.typography.fontSize.body,
			color: theme.colors.text.primary,
			borderWidth: 1,
			borderColor: theme.colors.border.secondary,
			...Platform.select({
				web: {
					outlineStyle: "none",
					outlineWidth: 0,
				} as any,
			}),
		},
		placeholder: {
			color: theme.colors.text.tertiary,
		},
		errorContainer: {
			backgroundColor: "rgba(217, 72, 115, 0.1)",
			borderRadius: theme.radii.md,
			paddingHorizontal: theme.spacing.md,
			paddingVertical: theme.spacing.sm,
			marginBottom: theme.spacing.lg,
		},
		errorText: {
			fontSize: theme.typography.fontSize.footnote,
			color: theme.colors.accent.rose,
			fontWeight: "400",
		},
		submitButton: {
			backgroundColor: theme.colors.accent.indigo,
			borderRadius: theme.radii.md,
			paddingVertical: theme.spacing.md,
			alignItems: "center",
			justifyContent: "center",
			minHeight: 48,
			cursor: Platform.select({ web: "pointer", default: "auto" }) as any,
		},
		submitButtonDisabled: {
			opacity: 0.5,
			cursor: Platform.select({ web: "not-allowed", default: "auto" }) as any,
		},
		submitButtonText: {
			fontSize: theme.typography.fontSize.body,
			fontWeight: "600",
			color: "#FFFFFF",
		},
	});
}

// Deprecated: kept for any existing imports/tests. New code should
// use `useComposeChatStyles()` (theme-reactive).
export const styles = composeChatStylesFor(lightTheme);
